import styles from "./skeletonCard.module.css";
import { color } from "../Data/cards";
import { Button } from "antd";
import {
  BorderBottomOutlined,
  CheckCircleFilled,
  CheckCircleTwoTone,
  DownCircleFilled,
  StarFilled,
} from "@ant-design/icons";
import { ref, set } from "firebase/database";
import { db } from "../utils/firebase";
import { useParams } from "react-router-dom";
import { UserOutlined } from "@ant-design/icons";
import { useContext } from "react";
import { MyContext } from "../utils/utils";

const SkeletonCard = ({ number = 0, userKey = false, currentJoiner, name }) => {
  const { key } = useParams();
  const { currentUser } = useContext(MyContext);
  const selectCurrentUser = () => {
    if (userKey) {
      set(ref(db, "rooms/" + key + "/previousJoiner"), currentUser.uid);
      set(ref(db, "rooms/" + key + "/currentJoiner"), userKey);
      set(ref(db, "rooms/" + key + "/selecting"), false);
    }
  };
  return (
    <div className={styles.skeletonCard}>
      <div
        className={styles.name}
        onClick={() => selectCurrentUser()}
        style={{
          color: currentJoiner
            ? number == 0
              ? "#1890ff"
              : color.white
            : color.black,
          display: "block",
        }}
      >
        {currentJoiner && (
          <div style={{ position: "absolute", top: "-20px", left: "24px" }}>
            <DownCircleFilled style={{ fontSize: "12px" }} />
          </div>
        )}
        <p>{name}</p>
      </div>
      {new Array(number).fill(0).map((value, index) => (
        <div
          className={styles.card}
          style={
            index == 0
              ? {
                  backgroundColor: currentJoiner ? "#096dd9" : color.white,
                  zIndex: `${number}`,
                }
              : {
                  background: `linear-gradient(-45deg, ${
                    color[Object.keys(color)[index % 4]]
                  }, ${color.white})`,
                  transform: `translate(${index * 2}px, ${index * 2}px)`,
                  zIndex: `${number - index}`,
                }
          }
        >
          {index == 0 &&
            (userKey ? (
              <div
                style={{
                  width: "60px",
                  paddingTop: "0px",
                  paddingLeft: "0px",
                  height: "80px",
                  margin: "0px",
                }}
                onClick={() => selectCurrentUser()}
              >
                <Button
                  icon={<CheckCircleFilled />}
                  type="link"
                  style={{ padding: "0px" }}
                ></Button>
              </div>
            ) : // <p className={styles.distance}>{number}</p>
            null)}
        </div>
      ))}

      {number == 0 && userKey && (
        <Button
          icon={<CheckCircleFilled />}
          type="link"
          onClick={() => selectCurrentUser()}
          style={{ transform: "10px" }}
        >
          선택하기
        </Button>
      )}
    </div>
  );
};

export default SkeletonCard;
